import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacultyService {
  private token = ''

  constructor(private http: HttpClient) { }

  getOverallDashboardData(selectedDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/totalDashBoardCountByDate?selectedDate=" + selectedDate, { headers })
  }

  getLosTableData(selectedDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/countByLocDashBoardByDate?selectedDate=" + selectedDate, { headers })
  }

  getStateTableData(los: any, selectedDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/countStatewiseByLocByDate?location=" + los + '&date=' + selectedDate, { headers })
  }

  getCityTableData(los: any, stateId: any, selectedDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/countCitywiseByLocByDate?location=" + los + "&stateId=" + stateId + '&date=' + selectedDate, { headers })
  }

  getCampusTableData(cityId: any, selectedDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/citywisePrinciplesList?cityId=" + cityId + '&date=' + selectedDate, { headers })
  }

  getSectionwise(campusId: any, selectedDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/getFacultyCampusWiseSectionDetails?campusId=" + campusId + "&selectedDate=" + selectedDate, { headers })
  }

  getcampusGoogle(campusId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.masterDomain + '/apiV2/campusGeolocationDetails?campusId=' + campusId, { headers });
  }

  getPendingDetails(selectDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + '/employee/api/jwtV2/faciltyDashBoard/pendingCampusPrinciplesList?date=' + selectDate, { headers });
  }


  getStateDetails(selectDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + '/employee/api/jwtV2/faciltyDashBoard/startedCampusPrinciplesList?date=' + selectDate, { headers });
  }



  getCampusTypeData(selectDate: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/countByCampusType?date=" + selectDate, { headers })
  }

  getAllPeriodsData() {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/teachPeriodsList", { headers })
  }

  getEmployeeAllowedCities() {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/empCities", { headers })
  }

  getEmployeeAllowedCityWiseCampus(cityId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/empCampusByCityId?cityId=" + cityId, { headers })
  }

  getEmployeeAllowedCampusWiseBuilding(campusId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("MasterService") + "/apiV2/common/empCmpBuilding?campusId=" + campusId, { headers })
  }

  getTableData(buildingId: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(localStorage.getItem("StudentAttendance") + "/employee/api/jwtV2/faciltyDashBoard/getFacultyTeachingSectionsWiseDetails?buildingId=" + buildingId + "&selectedDate=" + date, { headers })
  }

  getPeriodImage(payrollId: any, fileName: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });

    return this.http.get(
      localStorage.getItem("StudentAttendance") +
      "/employee/api/jwtV2/facultyTracking/downloadFacultyImageByPath?payrollId=" +
      payrollId +
      "&imagePath=" +
      fileName,
      { headers, responseType: 'blob' }
    );
  }

}
